import { Link } from "react-router-dom";
import { Seo } from "@/components/site/Seo";
import { PageIntro } from "@/components/site/PageIntro";
import { useLang } from "@/i18n";

export default function NotFound() {
  const { t, to } = useLang();
  return (
    <>
      <Seo page="notFound" />
      <PageIntro testId="not-found" overline={t.notFound.overline} title={t.notFound.title}>
        <Link to={to("home")} data-testid="not-found-home-link" className="mt-10 inline-flex px-7 py-3.5 rounded-full bg-[#1A2522] hover:bg-[#374F49] text-[#F8F6F0] text-[12px] tracking-[0.2em] uppercase font-semibold transition-colors">
          {t.notFound.home}
        </Link>
      </PageIntro>
    </>
  );
}
